import { RACButton, RACModal, RACRadio } from '@rentacenter/racstrap';
import clsx from 'clsx';
import React, { ChangeEvent, useState } from 'react';
import {
  createFVEventOptions,
  printLetterOptions,
} from '../../../constants/constants';
import { useFieldSheets } from '../../../context/FieldSheets/FieldSheetsProvider';
import { Option } from '../../../types/types';
import { useStyles } from './PrintLetterModal';
import { useStoreDetails } from '../../../context/Store/StoreProvider';
import { useTranslation } from 'react-i18next';

export interface ModalProps {
  onClose: (onclose: boolean) => void;
  onConfirm: (selectedOption: string, selectedFVOption: boolean) => void;
  customerName: string;
  disableActionButtons?: boolean;
  onlyOneCustomerSelected: boolean;
}

interface PrintLetterOptionsProps {
  options: Option[];
  selectedValue: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  style: string;
}

const generatePrintLetterOptions = ({
  options,
  selectedValue,
  onChange,
  style,
}: PrintLetterOptionsProps) =>
  options.map((option, index) => (
    <RACRadio
      name="printLetter"
      {...option}
      checked={option.value === selectedValue}
      classes={{ label: style }}
      onChange={onChange}
      key={index}
    />
  ));

interface CreateFieldVisitEventOptionsProps {
  options: Option[];
  selectedFVValue: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  style: string;
}

const createFieldVisitEventOptions = ({
  options,
  selectedFVValue,
  onChange,
  style,
}: CreateFieldVisitEventOptionsProps) =>
  options.map((option, index) => (
    <RACRadio
      name="createFVEvent"
      {...option}
      checked={option.value === selectedFVValue}
      classes={{ label: style }}
      onChange={onChange}
      key={index}
    />
  ));

export const PrintFieldSheetModal = ({
  onClose,
  onConfirm,
  customerName,
  onlyOneCustomerSelected,
}: ModalProps) => {
  const classes = useStyles();
  const { isLoading } = useFieldSheets();
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState<string>('NONE');
  const [selectedFVValue, setSelectedFVValue] = useState<string>('Y');
  const { isLMDEnabled } = useStoreDetails();
  const handleChange = (event: any) => {
    setSelectedValue(event.target.value);
  };
  const handleFVCreateEventChange = (event: any) => {
    setSelectedFVValue(event.target.value);
  };

  const printLetterOptionsLable = printLetterOptions.map((option) => ({
    ...option,
    label: t(`${option.label}`),
  }));
  const createFVEventOptionsLable = createFVEventOptions.map((option) => ({
    ...option,
    label: t(`${option.label}`),
  }));

  return isLMDEnabled && onlyOneCustomerSelected ? (
    <RACModal
      isOpen
      classes={{
        dialogContent: classes.dialogContent,
        dialogActions: classes.dialogActions,
        dialog: classes.dialogRoot,
      }}
      maxWidth="xs"
      title={t('Print Field Sheet')}
      content={
        <>
          <div className={clsx(classes.letter)}>
            <label className={clsx(classes.label)}>{customerName}</label>
          </div>
          {generatePrintLetterOptions({
            options: printLetterOptionsLable,
            selectedValue,
            onChange: handleChange,
            style: classes.radioLabel,
          })}
          <div className={clsx(classes.letter)}>
            <label className={clsx(classes.label)}>
              {t('Create Field Visit Event')}
            </label>
          </div>
          {createFieldVisitEventOptions({
            options: createFVEventOptionsLable,
            selectedFVValue,
            onChange: handleFVCreateEventChange,
            style: classes.radioLabel,
          })}
        </>
      }
      onClose={() => onClose(false)}
      buttons={
        <>
          <RACButton
            variant="outlined"
            color="secondary"
            onClick={() => onClose(false)}
          >
            {t('Cancel')}
          </RACButton>
          <RACButton
            disabled={isLoading}
            loading={isLoading}
            variant="contained"
            color="primary"
            onClick={() => {
              onConfirm(selectedValue, selectedFVValue == 'Y' ? true : false);
            }}
          >
            {t('Ok')}
          </RACButton>
        </>
      }
    />
  ) : (
    <RACModal
      isOpen
      classes={{
        dialogContent: classes.dialogContent,
        dialogActions: classes.dialogActions,
        dialog: classes.dialogRoot,
      }}
      maxWidth="xs"
      title={t('Print Field Sheet')}
      content={
        <>
          <div className={clsx(classes.letter)}>
            <label className={clsx(classes.label)}>{customerName}</label>
          </div>
          {generatePrintLetterOptions({
            options: printLetterOptionsLable,
            selectedValue,
            onChange: handleChange,
            style: classes.radioLabel,
          })}
        </>
      }
      onClose={() => onClose(false)}
      buttons={
        <>
          <RACButton
            variant="outlined"
            color="secondary"
            onClick={() => onClose(false)}
          >
            {t('Cancel')}
          </RACButton>
          <RACButton
            disabled={isLoading}
            loading={isLoading}
            variant="contained"
            color="primary"
            onClick={() => {
              onConfirm(selectedValue, false);
            }}
          >
            {t('Ok')}
          </RACButton>
        </>
      }
    />
  );
};
